
import { defineComponent, ref, watchEffect, computed } from "vue";
import { mainFormatter } from "@/utils/index";
import moment from "moment";
import InvestmentHistory from "@/components/widgets/lists/Widget5.vue";

export default defineComponent({
  name: "funding-rounds",
  props: {
    widgetClasses: String,
    fundingRounds: Array,
  },
  components: {
    InvestmentHistory,
  },
  setup(props) {
    const currencyCodeSymbolEnums = {
      dollar: "$",
      pound: "£",
      euro: "€",
    };
    const rounds = ref<Array<Record<string, unknown>>>([]);
    const formatDate = (date) => moment(date).format("YYYY-MM-DD");
    const formatter = computed(() => mainFormatter);
    watchEffect(() => {
      rounds.value = props.fundingRounds as Array<Record<string, unknown>>;
    });
    return {
      currencyCodeSymbolEnums,
      rounds,
      formatter,
      formatDate,
    };
  },
});
